import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Row, Col, Card, Divider, Avatar, Tag, Descriptions, Breadcrumb } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getDirecteur } from './directeur.reducer';
import OptionsDirecteur from './options-directeur';
import { UserOutlined } from '@ant-design/icons';
import { getEcole } from '../ecole/ecole.reducer';
export const DirecteurDetail = (props: RouteComponentProps<{ id: string; ecoleid: string }>) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getEcole(props.match.params.ecoleid));
    dispatch(getDirecteur(props.match.params.id));
  }, []);
  const directeurList = useAppSelector(state => state.directeur.entity);
  const currentEcole = useAppSelector(state => state.ecole.entity);

  const { match } = props;
  return (
    <>
      <Breadcrumb className="p-2">
        <Breadcrumb.Item>
          <Link to={`/home/${currentEcole && currentEcole.id}`}>{currentEcole && currentEcole.nom}</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`/directeur/${currentEcole && currentEcole.id}`}>Directeurs</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`${match.url}`}>Details</Link>
        </Breadcrumb.Item>
      </Breadcrumb>
      <Card>
        {directeurList.id !== null && (
          <Row className="justify-content-center">
            <Col lg={{ span: 6 }} xs={{ span: 24 }} sm={{ span: 8 }} md={{ span: 5 }}>
              <Descriptions column={1} className="p-2">
                <Descriptions.Item>
                  <Avatar size={{ xs: 80, sm: 100, md: 100, lg: 120, xl: 150, xxl: 100 }} icon={<UserOutlined />} />
                </Descriptions.Item>
                <Descriptions.Item label="Statut">
                  {directeurList.activated ? (
                    <Tag color="green" className="ml-2">
                      Activé{' '}
                    </Tag>
                  ) : (
                    <Tag color="red" className="ml-2">
                      Désactivé
                    </Tag>
                  )}
                </Descriptions.Item>
                <Descriptions.Item label="Role">
                  <Tag color="gray" className="ml-2">
                    {directeurList.authorities?.map(d => d)}
                  </Tag>
                </Descriptions.Item>
              </Descriptions>
            </Col>

            <Divider type="vertical" style={{ height: 'auto' }} />
            <Col lg={{ span: 10 }} xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 9 }}>
              <h2 style={{ textAlign: 'center' }} className="p-2">
                {' '}
                {directeurList.firstName} {directeurList.lastName}{' '}
              </h2>
              <span>
                <Descriptions column={1}>
                  <Descriptions.Item label="Login">{directeurList.login}</Descriptions.Item>
                  <Descriptions.Item label="Email">{directeurList.email}</Descriptions.Item>
                  <Descriptions.Item label="Téléphone">{directeurList.telephone}</Descriptions.Item>
                </Descriptions>
              </span>
            </Col>
            <Divider type="vertical" style={{ height: 'auto' }} />
            <Col lg={{ span: 4 }} xs={{ span: 24 }} md={{ span: 8 }} sm={{ span: 8 }} style={{ textAlign: 'center' }}>
              <OptionsDirecteur {...props} />
            </Col>
          </Row>
        )}
      </Card>
    </>
  );
};
export default DirecteurDetail;
